var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLauchingSoonImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 285.38 146.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-20{fill:none;}.cls-10,.cls-2{fill:#929799;}.cls-2{opacity:0.1;}.cls-3{fill:#b9b9b9;}.cls-4{fill:#f0f0f0;}.cls-5{fill:#fbfbfb;}.cls-6{clip-path:url(#clip-path);}.cls-7{fill:#252728;}.cls-8{fill:#e6e6e6;}.cls-9{fill:#fe4800;}.cls-11{fill:#72787a;}.cls-12{fill:#feac00;}.cls-13{fill:#fefefe;}.cls-14{fill:#a5a1a9;opacity:0.33;}.cls-15{font-size:11.64px;fill:#fff;font-family:Montserrat-Bold, Montserrat;font-weight:700;}.cls-16{font-size:6.93px;}.cls-17{letter-spacing:-0.02em;}.cls-18{letter-spacing:-0.01em;}.cls-19{letter-spacing:-0.01em;}.cls-20{stroke:#252728;stroke-miterlimit:10;}.cls-21{font-size:5.39px;fill:#1c1714;font-family:Montserrat-ExtraBold, Montserrat;font-weight:800;}.cls-22{letter-spacing:0.01em;}.cls-23{letter-spacing:-0.01em;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.48,
    y: 39.88,
    width: 122.32,
    height: 71.64,
    rx: 4.98
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 134.66,
    cy: 140.54,
    rx: 134.66,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162,122.41q.41,2.85.94,5.87c.31,1.73.64,3.42,1,5.05L141.71,138l1.52-15.44a40.4,40.4,0,0,1,7.8-1.13A39.91,39.91,0,0,1,162,122.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.79,126.9q7.2,2.1,14.54,4.36c2.22.69,4.42,1.37,6.61,2.07.16,1.06.32,2.13.49,3.2.06,1.32-.75,1.45-1.82,1.45-6.94,0-13.88,0-20.82,0Q142.29,132.42,142.79,126.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 91.6,
    y: 103.05,
    width: 120.58,
    height: 20.02,
    rx: 2.44
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.69,
    y: 39.8,
    width: 122.32,
    height: 71.64,
    rx: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 148.17,
    y: 72.15,
    width: 72.05,
    height: 10.52,
    transform: "translate(-14.62 57.57) rotate(-17.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M165.46,87.94c.47-.92.91-1.78,1.34-2.64q2.05-4.1,4.09-8.2a1.74,1.74,0,0,1,1.25-1c2.14-.61,6.69-2.1,6.79-2s0,.18-.07.28q-1.53,3-3.05,6.06l-2.43,4.85a.63.63,0,0,1-.43.39c-2.42.73-4.83,1.48-7.25,2.22A1,1,0,0,1,165.46,87.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M177.79,84.15c.46-.92.9-1.78,1.34-2.65q2.06-4.09,4.09-8.19a1.74,1.74,0,0,1,1.24-1c2.15-.61,4.28-1.3,6.41-1.95.13,0,.29-.16.39-.06s0,.18-.07.28l-3.06,6.06c-.81,1.61-1.61,3.23-2.42,4.84a.62.62,0,0,1-.43.4c-2.42.73-4.84,1.48-7.25,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M190.12,80.36c.46-.92.9-1.78,1.34-2.65,1.36-2.73,2.74-5.46,4.09-8.19a1.72,1.72,0,0,1,1.24-1c2.15-.61,4.27-1.3,6.41-2,.13,0,.29-.16.39-.06s0,.18-.08.28l-3,6.06L198,77.7a.64.64,0,0,1-.44.4c-2.42.73-4.83,1.48-7.24,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M202.45,76.56c.46-.91.9-1.77,1.33-2.64q2.06-4.1,4.09-8.19a1.72,1.72,0,0,1,1.25-1c2.14-.62,4.27-1.3,6.41-1.95.12,0,.28-.16.38-.06s0,.18-.07.27q-1.53,3-3.05,6.06c-.81,1.62-1.61,3.24-2.43,4.85a.64.64,0,0,1-.43.4c-2.42.73-4.83,1.48-7.25,2.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.91,
    y: 91.37,
    width: 72.05,
    height: 10.52,
    transform: "translate(-23.02 40.12) rotate(-17.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.88,111c.46-.92.9-1.78,1.33-2.65,1.37-2.73,2.75-5.46,4.09-8.19a1.76,1.76,0,0,1,1.25-1c2.15-.61,4.27-1.3,6.41-2,.12,0,.29-.16.39-.06s0,.18-.08.28q-1.53,3-3,6.06c-.81,1.61-1.61,3.23-2.42,4.84a.66.66,0,0,1-.44.4c-2.42.73-4.83,1.48-7.24,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M103.21,107.16c.46-.92.9-1.78,1.33-2.65q2.05-4.1,4.09-8.19a1.72,1.72,0,0,1,1.25-1c2.14-.61,4.27-1.3,6.41-2,.12,0,.28-.16.38-.06s0,.18-.07.28q-1.53,3-3,6.06l-2.43,4.84a.62.62,0,0,1-.43.4c-2.42.73-4.83,1.48-7.25,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M115.53,103.36c.47-.91.91-1.77,1.34-2.64q2.05-4.09,4.09-8.19a1.72,1.72,0,0,1,1.24-1c2.15-.62,4.28-1.3,6.41-2,.13,0,.29-.15.39-.06s0,.19-.07.28q-1.53,3-3.05,6.06l-2.43,4.85a.66.66,0,0,1-.43.4c-2.42.73-4.83,1.48-7.25,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M127.86,99.57l1.34-2.64c1.36-2.73,2.74-5.46,4.09-8.2a1.76,1.76,0,0,1,1.24-1c2.15-.61,4.27-1.29,6.41-1.95.13,0,.29-.15.39-.06s0,.19-.08.28q-1.51,3-3.05,6.06l-2.42,4.85a.66.66,0,0,1-.44.4c-2.41.73-4.83,1.47-7.24,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M140.19,95.78l1.33-2.64c1.37-2.73,2.75-5.46,4.09-8.2a1.78,1.78,0,0,1,1.25-1c2.15-.61,6.7-2.1,6.8-2s0,.18-.08.28q-1.53,3-3.05,6.06l-2.42,4.85a.65.65,0,0,1-.44.39l-7.24,2.22A1.24,1.24,0,0,1,140.19,95.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M153.14,91.73l1.33-2.64q2.06-4.09,4.09-8.2a1.76,1.76,0,0,1,1.25-1c2.14-.61,6.69-2.1,6.79-2s0,.18-.07.28q-1.53,3-3.05,6.06c-.81,1.62-1.61,3.23-2.43,4.85a.61.61,0,0,1-.43.39l-7.25,2.22A1,1,0,0,1,153.14,91.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 142.88,
    y: 95.58,
    width: 72.05,
    height: 10.52,
    transform: "translate(24.67 -34.76) rotate(11.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M157.42,101c.84-.58,1.65-1.12,2.45-1.66,2.52-1.73,5-3.45,7.55-5.19a1.75,1.75,0,0,1,1.57-.26c2.17.51,6.87,1.41,6.92,1.54s-.11.15-.2.21l-5.61,3.82-4.47,3.06a.64.64,0,0,1-.57.14c-2.47-.54-4.95-1.05-7.42-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M170,103.62l2.45-1.66L180,96.78a1.75,1.75,0,0,1,1.57-.27c2.17.51,4.36.94,6.55,1.41.13,0,.32,0,.37.13s-.11.15-.2.21q-2.82,1.9-5.61,3.82l-4.47,3.06a.64.64,0,0,1-.57.14l-7.42-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M182.66,106.28l2.45-1.66q3.78-2.58,7.55-5.18a1.72,1.72,0,0,1,1.57-.26c2.17.5,4.36.93,6.55,1.4.13,0,.32,0,.37.13s-.12.15-.2.21c-1.88,1.27-3.75,2.55-5.61,3.82-1.49,1-3,2.05-4.47,3.06a.63.63,0,0,1-.58.14l-7.41-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M195.28,109l2.45-1.67q3.78-2.58,7.55-5.18a1.72,1.72,0,0,1,1.57-.26c2.17.5,4.36.94,6.55,1.4.13,0,.32,0,.37.14s-.12.14-.21.2L208,107.4l-4.47,3.07a.66.66,0,0,1-.58.13L195.5,109Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 79.12,
    y: 82.19,
    width: 72.05,
    height: 10.52,
    transform: "translate(20.53 -21.89) rotate(11.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M81,84.91l2.45-1.66c2.52-1.73,5-3.45,7.55-5.19a1.76,1.76,0,0,1,1.57-.26c2.18.51,4.37.94,6.55,1.4.13,0,.33,0,.37.14s-.11.15-.2.21l-5.61,3.82-4.47,3.06a.64.64,0,0,1-.57.14c-2.47-.54-4.94-1-7.41-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M93.65,87.57l2.45-1.66c2.52-1.73,5.05-3.45,7.55-5.18a1.76,1.76,0,0,1,1.57-.27c2.17.51,4.37.94,6.55,1.41.13,0,.33,0,.37.13s-.11.15-.2.21L106.33,86l-4.47,3.06a.64.64,0,0,1-.57.14l-7.41-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M106.27,90.23l2.45-1.66c2.52-1.72,5-3.44,7.55-5.18a1.73,1.73,0,0,1,1.57-.26c2.17.5,4.37.93,6.55,1.4.13,0,.33,0,.37.13s-.11.15-.2.21L119,88.69l-4.47,3.06a.62.62,0,0,1-.57.14l-7.41-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118.89,92.9l2.45-1.66c2.52-1.73,5-3.45,7.55-5.19a1.73,1.73,0,0,1,1.57-.26c2.17.51,4.37.94,6.55,1.4.13,0,.33,0,.37.14s-.11.14-.2.2l-5.61,3.82-4.47,3.07a.64.64,0,0,1-.57.13L119.11,93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M131.51,95.56,134,93.9c2.52-1.73,5-3.45,7.55-5.19a1.75,1.75,0,0,1,1.57-.26C145.25,89,150,89.86,150,90s-.11.15-.2.21L144.19,94l-4.47,3.06a.64.64,0,0,1-.57.14c-2.47-.54-4.94-1-7.42-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M144.8,98.3l2.45-1.67q3.78-2.58,7.55-5.18a1.72,1.72,0,0,1,1.57-.26c2.17.5,6.87,1.41,6.92,1.54s-.11.14-.2.2l-5.61,3.82L153,99.82a.64.64,0,0,1-.57.13L145,98.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 148.4,
    y: 87.79,
    width: 72.05,
    height: 10.52,
    transform: "translate(-2.15 4.38) rotate(-1.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M163.54,98.1c.69-.75,1.35-1.46,2-2.18,2.06-2.26,4.12-4.51,6.16-6.78a1.76,1.76,0,0,1,1.47-.61c2.23,0,7-.21,7.09-.09s-.08.16-.15.24l-4.58,5c-1.22,1.33-2.43,2.67-3.65,4a.66.66,0,0,1-.53.26l-7.57.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M176.43,97.8l2-2.18c2.05-2.26,4.12-4.52,6.16-6.78a1.71,1.71,0,0,1,1.46-.62c2.23,0,4.47-.09,6.7-.14.13,0,.32-.07.39,0s-.07.17-.15.25l-4.58,5c-1.22,1.34-2.43,2.68-3.65,4a.65.65,0,0,1-.52.27c-2.53,0-5.05.11-7.58.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M189.33,97.49c.69-.75,1.35-1.46,2-2.18,2.06-2.26,4.12-4.51,6.16-6.78a1.74,1.74,0,0,1,1.47-.61c2.23,0,4.46-.09,6.69-.14.14,0,.32-.07.39,0s-.07.16-.14.24l-4.58,5c-1.22,1.33-2.43,2.67-3.65,4a.63.63,0,0,1-.53.26l-7.58.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M202.22,97.19l2-2.18q3.09-3.39,6.16-6.78a1.74,1.74,0,0,1,1.47-.62c2.23,0,4.47-.09,6.7-.14.13,0,.32-.07.39,0s-.08.17-.15.25c-1.53,1.67-3.06,3.33-4.58,5-1.22,1.34-2.43,2.68-3.65,4a.66.66,0,0,1-.52.27c-2.53,0-5.06.11-7.58.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 83.27,
    y: 89.39,
    width: 72.05,
    height: 10.52,
    transform: "translate(-2.2 2.85) rotate(-1.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M85.51,100c.69-.75,1.35-1.46,2-2.18,2.06-2.26,4.12-4.51,6.16-6.78a1.75,1.75,0,0,1,1.47-.61c2.23,0,4.46-.09,6.7-.14.13,0,.31-.07.39,0s-.08.16-.15.24l-4.58,5c-1.22,1.33-2.43,2.67-3.65,4a.66.66,0,0,1-.53.26l-7.57.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M98.4,99.71l2-2.18c2-2.26,4.12-4.52,6.16-6.78a1.71,1.71,0,0,1,1.46-.62c2.23,0,4.47-.09,6.7-.14.13,0,.32-.07.39.05s-.07.17-.15.25l-4.58,5c-1.22,1.34-2.43,2.68-3.65,4a.65.65,0,0,1-.52.27c-2.53,0-5,.11-7.58.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.3,99.4c.69-.75,1.35-1.46,2-2.18,2.06-2.26,4.12-4.51,6.16-6.78a1.74,1.74,0,0,1,1.47-.61c2.23,0,4.46-.09,6.69-.14.14,0,.32-.07.39,0s-.07.17-.14.24l-4.58,5c-1.22,1.33-2.43,2.67-3.65,4a.65.65,0,0,1-.53.26l-7.58.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M124.19,99.1l2-2.18q3.09-3.39,6.16-6.78a1.74,1.74,0,0,1,1.47-.62c2.23,0,4.46-.09,6.7-.14.13,0,.32-.07.39.05s-.08.17-.15.25c-1.53,1.67-3.06,3.33-4.58,5-1.22,1.34-2.43,2.68-3.65,4A.67.67,0,0,1,132,99c-2.52,0-5,.11-7.57.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M137.08,98.79c.7-.75,1.36-1.46,2-2.18,2-2.26,4.12-4.51,6.16-6.78a1.73,1.73,0,0,1,1.46-.61c2.24,0,7-.21,7.09-.09s-.07.17-.15.25c-1.53,1.66-3.05,3.33-4.58,5-1.22,1.33-2.43,2.67-3.65,4a.61.61,0,0,1-.52.26l-7.58.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M150.64,98.41l2-2.18q3.09-3.39,6.16-6.78a1.71,1.71,0,0,1,1.47-.62c2.23,0,7-.21,7.08-.09s-.07.17-.14.25l-4.59,5q-1.81,2-3.64,4a.68.68,0,0,1-.53.27c-2.53,0-5.05.11-7.58.17Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "91.23 24.56 91.23 47.98 95.19 47.98 95.19 23.75 91.23 24.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M129,16.33a3.88,3.88,0,0,1-1.69-.62c-.22-.78-1-1.06-1.55-1.46-3.49-2.37-4.49-5.43-3.1-9.27.26-.7.87-1.33.57-2.16-.76-.57-1.42-.1-2.09.18-4.69,2-9.14,4.39-13.73,6.54-3.72,1.74-7.37,3.61-11.13,5.27-1,.42-1.9.84-2.09,2,.06.84.76,1.18,1.37,1.58A3.73,3.73,0,0,1,97.51,22c-.07,1-.32,2.1.61,3,1.83-.46,3.66-.88,5.48-1.37,2.89-.8,5.77-1.65,8.65-2.46,3.24-.92,6.48-1.81,9.71-2.72C124.32,17.7,126.67,17,129,16.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M204.53,39.87l60.71,87.34L285.38,115,217,31.68l-12.46,8.19Zm22.61,9.68L227,50l-11-1.14-.8-1.55,1.52-8.73.37-1,1,.63,9,11.37Zm29,38.11-11.88.19-1-1.37,3.32-10.79,1.06-.29,9.06,11.21-.53,1Zm14.33,18.92-10.68.66-2-2.51,3.95-11.37,7.17,8.89,2.44,2.83-.87,1.5Zm-10.67,4.85.78-1.41,11.55-.63,1.58,2.13-4.22,10.7-1.85.32-6.84-9.44-1-1.67ZM245.94,92.26,245.57,91l1.25-.39L258,90.4l1.15,1.52-3.72,10.69-.59,1.15-1.11-.8-7.81-10.7ZM231.86,71.53l1.43-.23,9.51.19,1.37,1.78-2.66,9.25-.74,1.57L239.26,83l-6.45-9.3,0,0-.42-.71-.49-1.45Zm-2.69-4.62,2.46-9.75.47-.8.8.45,8.56,10.74-.6,1.22-2.71-.08-7.78-.27-1.2-1.51ZM217.72,52l3,.07,7.08.57,1.62,1.11-2.64,11.12L225.19,63l-5.94-8.46L217.72,52Zm-7.85-12.35,3.27-1.95,1.06.54-1,5.95-.5.82-.92-.57L209.43,41l.44-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M188.06,20.53l.81,0,2.51.63,7.75,2.15,2-4.6L157.85,8.54,133.38,2l-5.83,13.15L195,32.83l3.33-7.62-4.6,3.11-2.08-.43-3.43-6.61-.11-.75ZM136,13.14l-1.46-3.33,0,0-1.32-3-.11-1,1,.12,9.3,2.37,1.09.63-.77,1-6.06,3.74L136,13.14Zm15.82,4.33-.69.77-10.44-2.85-.64-.46.46-.6,6.57-4.2,1.38.34,3.36,7Zm2.67.77-3-6.64,1-.91,3.66,1,7.1,2-7,5-1.71-.52Zm15.75,4.64-1.11.16-9.46-2.55-.32-1.55,6.09-3.71,1.88.64,2.5,5,.42,2Zm2.69-.13-1.39-3.18-.1,0L170,16.43l.58-.82,10.14,2.71.26,1.25-6.38,3.89-1.71-.71ZM188.77,28l-.94.14-10-2.73-.72-.59.6-.51,6.4-4.18,1.35.38,3,6,.31,1.47Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 203.57,
    cy: 28.42,
    rx: 13.35,
    ry: 12.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 128.34,
    cy: 9.43,
    rx: 9.96,
    ry: 9.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 94.84,
    cy: 22.01,
    rx: 6.42,
    ry: 6.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M245.72,139.57a.63.63,0,0,0-.87-.07,2.22,2.22,0,0,1-.5.1c-.89,0-1.78,0-2.67,0-1.71,0-1.67,0-2-1.74-.41-2.08-.95-4.12-1.52-6.16a.78.78,0,0,0-.63-.25c-2,0-4,0-6.07.05a.91.91,0,0,0-.73.28c-.14-.32-.44-.3-.69-.23a1.71,1.71,0,0,1-.81,0,7.06,7.06,0,0,0-1,.06c-1.92,0-3.85,0-5.77,0-.29,0-.61,0-.83.24-.55,2.47-1.1,5-1.63,7.42-.09.41-.21.6-.7.6-1.51,0-3,.06-4.53.06-.71,0-.41.5-.49.81s.23.38.47.38c.81,0,1.62,0,2.43-.05l4.46,0c1.54,0,3.07,0,4.61-.06a36.32,36.32,0,0,0,3.76-.11,3.1,3.1,0,0,0,.5.09l7-.11c2.34,0,4.68,0,7-.06.4,0,.9.2,1.26-.21C245.94,140.23,246,139.87,245.72,139.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237.37,128.36c-.47-2.25-1-4.49-1.66-6.7-.2-.24-11.59-.18-11.92.13q-1.11,5-2.2,10.06c.14,0,14.68-.11,16.55-.13A17,17,0,0,0,237.37,128.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M234.81,117.91c-.41-2.27-1.17-4.47-1.57-6.75-.21-1.19-.28-1.26-1.46-1.27a10.41,10.41,0,0,0-2.16.07h0c-.74,0-1.49-.08-2.24-.06-.95,0-.95,0-1.19,1,0,.15-.11.28-.14.43q-1.14,5.2-2.26,10.42c2,0,10-.13,11.92-.13A34.66,34.66,0,0,0,234.81,117.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "222.58 126.81 223.13 123.53 239.66 137.88 222.58 126.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M199.13,141.17a.63.63,0,0,0,.39-.79,3,3,0,0,1,.1-.5c.32-.83.65-1.65,1-2.48.64-1.58.65-1.54,2.37-1.21,2.08.4,4.18.67,6.28.91a.71.71,0,0,0,.46-.48c.78-1.87,1.5-3.77,2.25-5.65a.87.87,0,0,0,0-.77c.34,0,.44-.29.47-.55a2,2,0,0,1,.35-.74,5.44,5.44,0,0,0,.33-1c.75-1.78,1.41-3.59,2.15-5.37a.91.91,0,0,0,.09-.85c-2.08-1.44-4.16-2.88-6.26-4.31-.34-.24-.47-.42-.28-.87.59-1.4,1.08-2.83,1.65-4.22.27-.65-.31-.57-.57-.76s-.44.07-.53.29c-.3.75-.57,1.52-.87,2.27-.54,1.39-1.1,2.77-1.65,4.15s-1.15,2.84-1.69,4.28c-.44,1.18-1,2.31-1.32,3.53a2.73,2.73,0,0,0-.26.43c-.86,2.18-1.7,4.36-2.56,6.54s-1.76,4.33-2.58,6.52c-.15.38-.53.76-.29,1.25C198.43,141.12,198.73,141.34,199.13,141.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M212.66,137.66c2.26.41,4.55.73,6.83,1,.3-.1,4.54-10.66,4.38-11.09l-8.49-5.83c-.07.12-5.43,13.64-6.12,15.37A17,17,0,0,0,212.66,137.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M223.3,139.24c2.26.47,4.58.59,6.84,1.08,1.19.26,1.28.22,1.73-.87a9.61,9.61,0,0,0,.75-2h0c.31-.68.64-1.35.9-2.05.34-.89.31-.9-.51-1.5-.12-.09-.22-.21-.35-.29l-8.79-6c-.73,1.83-3.64,9.27-4.38,11.09A37.69,37.69,0,0,0,223.3,139.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "181.26 139.34 179.36 139.34 165.72 83.99 167.62 83.99 181.26 139.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "172.8 139.34 170.9 139.34 157.26 83.99 159.16 83.99 172.8 139.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "168 90.16 160.4 90.16 160.03 88.68 167.64 88.68 168 90.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "169.39 96.61 161.79 96.61 161.42 95.14 169.03 95.14 169.39 96.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "170.5 103.07 162.89 103.07 162.53 101.59 170.13 101.59 170.5 103.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "173 109.53 165.4 109.53 165.03 108.05 172.64 108.05 173 109.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "174.39 115.98 166.79 115.98 166.42 114.51 174.03 114.51 174.39 115.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "175.5 122.44 167.89 122.44 167.53 120.97 175.13 120.97 175.5 122.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "177.2 128.9 169.6 128.9 169.24 127.42 176.84 127.42 177.2 128.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "178.59 135.35 170.99 135.35 170.63 133.88 178.23 133.88 178.59 135.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M91.49,63.21H87.4a9.62,9.62,0,0,1-.47-1.92c-.54-3.49,1.13-5.94,4.22-7.56.12-.06.21-.14.33-.2a8.51,8.51,0,0,0,0-1.67c0-.75,0-1.51,0-2.26,0-.22,0-.4.3-.42a14.65,14.65,0,0,1,2.73,0,.29.29,0,0,1,.16.11c0,1.94,0,3.89,0,5.84,0,.29-.08.41-.39.47a5,5,0,0,0-3.41,2.27c-.82,1.36-1.05,3.56.14,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M102.35,37.49H82.62a1.42,1.42,0,0,0-.64,1.2c.07.55,1.81,8.68,2,9.43a1.48,1.48,0,0,0,1,1.22.73.73,0,0,0,.48.13c2-.06,3.9.07,5.85.12.75,0,1.51,0,2.27,0,2,.07,3.9-.2,5.85-.12a1,1,0,0,0,.48-.11A1.59,1.59,0,0,0,101.05,48c.26-1.5,2-9.52,1.76-9.91A1.6,1.6,0,0,0,102.35,37.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 66.61,
    y: 63.38,
    width: 59.95,
    height: 59.95,
    rx: 12,
    transform: "translate(69.97 -38.31) rotate(34.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "matrix(0.98, -0.21, 0.24, 0.97, 73.59, 95.87)"
  }, "UNDER", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: -7.04,
    y: 8.31
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: -2.07,
    y: 8.31
  }, "ON"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 9.38,
    y: 8.31
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.73,
    y: 8.31
  }, "TRU"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 28.56,
    y: 8.31
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.59,
    y: 8.31
  }, "TION"))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 68.74,
    y: 65.51,
    width: 55.68,
    height: 55.68,
    rx: 12,
    transform: "translate(69.97 -38.31) rotate(34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M97.44,56.67s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M101.11,59.25a3.42,3.42,0,0,1-.13-.84,2.17,2.17,0,0,0-.4-1.41l-.07,0a1.58,1.58,0,0,0-.54-.81v-.08a2,2,0,0,0-2.52.57v0a1.83,1.83,0,0,0,0,1.36,3.54,3.54,0,0,1,.42,1.22,3.61,3.61,0,0,1-1.2,4,2.71,2.71,0,0,1-1.39.87c-.37.14-.79.1-1.15.27-.71,0-.76.51-.81,1,0,.23,0,.47,0,.71a1.12,1.12,0,0,0,1,1.07,3.67,3.67,0,0,0,2.4-.46c.47-.23,1-.45,1.4-.71a6.69,6.69,0,0,0,2.52-2.73,1.33,1.33,0,0,0,.05-.19A8.51,8.51,0,0,0,101.11,59.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 53.37,
    y: 104.11,
    width: 7.56,
    height: 38.33,
    rx: 3.57,
    transform: "translate(-30.78 19.69) rotate(-15.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 15.75,
    y: 103.62,
    width: 7.56,
    height: 38.33,
    rx: 3.57,
    transform: "translate(-32.01 9.64) rotate(-15.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 6.74,
    y: 101.02,
    width: 7.56,
    height: 41.79,
    rx: 3.57,
    transform: "translate(34.71 1.96) rotate(16.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 43.57,
    y: 102.22,
    width: 7.56,
    height: 41.79,
    rx: 3.57,
    transform: "translate(36.54 -8.35) rotate(16.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 11.21,
    y: 101.94,
    width: 8.25,
    height: 3.51,
    rx: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 14.2,
    y: 98.51,
    width: 2.28,
    height: 4.91,
    rx: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 15.15,
    cy: 95.83,
    r: 3.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 15.15,
    cy: 95.83,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11,121.79c-2.58-.06-5.17-.08-7.78,0l-1.54,6,1.56-1c2.45-1.48,4.87-3,7.31-4.46C10.77,122.18,11.08,122.05,11,121.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M53.66,121.9c-1.32,0-2.65,0-4,0a2.53,2.53,0,0,0-.78.36l-12.41,7.58c-.25.15-.59.28-.6.56,2.79.05,5.58.07,8.39,0a2.59,2.59,0,0,0,.72-.32c2.59-1.57,5.18-3.16,7.76-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.4,121.82c2.78-.06,5.54,0,8.29,0a1.91,1.91,0,0,1-.82.7l-12.1,7.39a5.08,5.08,0,0,1-.85.4c-2.82.06-5.61,0-8.4,0,.07-.26.39-.39.65-.55l12.37-7.55A2.33,2.33,0,0,1,18.4,121.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M28.57,130.38c2-1.21,3.93-2.43,5.91-3.63L42,122.14a.45.45,0,0,1,.37-.26l7.28,0-8.88,5.45-4.91,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.82,125.16l-5.29,3.22a33.15,33.15,0,0,0-3.25,2.05l7.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M11,121.79c-.06.07-.09.16-.18.21-3,1.84-6.06,3.67-9.08,5.52L1,130.3H4.52l13.88-8.49Q14.71,121.73,11,121.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M33.89,122c-1.8,1.08-3.62,2.16-5.41,3.25l-8,4.87a3.3,3.3,0,0,0-.3.22l-7.29,0c2-1.23,4-2.47,6-3.69,2.34-1.45,4.7-2.87,7.05-4.31l.76-.49H34C34,121.92,34,122,33.89,122Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.4,121.88c-2.79-.09-5.62,0-8.44,0l0,.09a2.23,2.23,0,0,0-.91.38l-12.23,7.47c-.26.16-.57.3-.58.57,2.78.06,5.56.08,8.36,0a4.67,4.67,0,0,0,1.05-.52Q35.2,126.44,40.8,123c.3-.19.62-.37.91-.57s.37-.21.34-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14.85,108c-2.58-.06-5.17-.09-7.78,0l-1.54,6,1.56-1c2.45-1.48,4.87-3,7.31-4.45C14.63,108.38,14.94,108.25,14.85,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57.52,108.09c-1.32,0-2.65,0-4,0a2.55,2.55,0,0,0-.78.37l-12.41,7.57c-.25.15-.59.28-.6.56,2.79,0,5.58.08,8.39,0a3.35,3.35,0,0,0,.72-.32l7.76-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.26,108c2.78-.05,5.54,0,8.29,0a1.91,1.91,0,0,1-.82.7l-12.1,7.39a6.06,6.06,0,0,1-.85.41c-2.82,0-5.61,0-8.4,0,.07-.26.39-.4.65-.55L21.4,108.4A2.5,2.5,0,0,1,22.26,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32.43,116.58l5.91-3.64,7.55-4.61a.44.44,0,0,1,.37-.25l7.28,0c-3,1.82-5.92,3.63-8.88,5.46l-4.91,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M56.68,111.36l-5.29,3.22a31.36,31.36,0,0,0-3.25,2l7.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M14.85,108a.57.57,0,0,1-.18.2l-9.08,5.52-.72,2.78,3.51,0L22.26,108C19.8,108,17.33,108,14.85,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M37.75,108.22c-1.8,1.08-3.62,2.15-5.41,3.24l-8,4.87a3.4,3.4,0,0,0-.3.23l-7.29,0q3-1.86,6-3.7l7.05-4.31c.26-.15.51-.32.76-.49l7.27,0C37.87,108.11,37.87,108.17,37.75,108.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.26,108.08c-2.79-.1-5.62-.06-8.44,0l0,.08a2.12,2.12,0,0,0-.91.39L24.65,116c-.26.15-.57.29-.58.57,2.78,0,5.56.07,8.36,0a5.17,5.17,0,0,0,1-.53l11.18-6.82c.3-.19.62-.36.91-.57s.37-.2.34-.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 48.15,
    y: 101.44,
    width: 8.25,
    height: 3.51,
    rx: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 51.14,
    y: 98.02,
    width: 2.28,
    height: 4.91,
    rx: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 52.09,
    cy: 95.34,
    r: 3.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 52.09,
    cy: 95.34,
    r: 3.2
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-21",
    transform: "translate(83.97 110.63) rotate(-13.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.33,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.48,
    y: 0
  }, "UNCHING"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6.47,
    xmlSpace: "preserve"
  }, "     SOON!"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLauchingSoonImage);
export default __webpack_public_path__ + "static/media/lauching-soon-image.4190bf7ec85a2bc6e2defde42effa131.svg";
export { ForwardRef as ReactComponent };